import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { Button } from "reactstrap";
import setorService from "../../../../services/SetorService";
import DynamicMaterialTable from "components/Common/MaterialTableContainer";
import useTableZoom from "components/Common/useTableZoom";
import Loading from "components/Common/Loading";
import { IconButton, Tooltip } from "@mui/material";
import { PencilSimple } from "@phosphor-icons/react";
import {
	getTableBodyCellProps,
	getTableHeaderCellProps,
} from "components/Common/MaterialTableStyles";

const Setores = () => {
	// ========== CONFIGURAÇÃO DE LARGURAS MÍNIMAS E MÁXIMAS DAS COLUNAS ==========
	const COLUMN_WIDTHS = {
		name: { min: 200 },           // Largura mínima da coluna "Nome" (sem máximo - cresce livremente)
		actions: { min: 80, max: 80 }, // Largura mín/máx da coluna "Ações" (em pixels)
	};
	// ================================================================

	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const navigate = useNavigate();

	// Usar o hook customizado para zoom e cálculos de largura
	const { zoomLevel, getColumnWidth } = useTableZoom(COLUMN_WIDTHS);

	document.title = "Senda | Setores";

	const columns = useMemo(
		() => [
			{
				header: "Nome",
				accessorKey: "name",
				filterFn: "contains",
				widthPixels: getColumnWidth('name'),
				minWidthPixels: COLUMN_WIDTHS.name.min,
				// Não tem maxWidthPixels - pode crescer livremente
				...getTableHeaderCellProps(),
				...getTableBodyCellProps("firstColumn"),
			},
			{
				header: <span>Ações</span>,
				accessorKey: "actions",
				enableColumnFilter: false,
				enableColumnActions: false,
				enableSorting: false,
				widthPixels: getColumnWidth('actions'),
				minWidthPixels: COLUMN_WIDTHS.actions.min,
				maxWidthPixels: COLUMN_WIDTHS.actions.max,
				...getTableHeaderCellProps(),
				...getTableBodyCellProps("actionColumn"),
				Cell: ({ row }) => (
					<div style={{ 
						display: "flex", 
						alignItems: "center",
						justifyContent: "center",
						width: "100%",
						height: "100%",
					}}>
						<Tooltip title="Editar" placement="top">
							<IconButton
								style={{
									background: "none",
									border: "none",
									padding: "1px",
									cursor: "pointer",
									color: "black",
									minWidth: "auto",
									width: "auto",
									height: "auto",
								}}
								onClick={() => editarItem(row.original)}
							>
								<PencilSimple size={14} />
							</IconButton>
						</Tooltip>
					</div>
				),
				align: "center",
			},
		],
		[zoomLevel], // Adicionado zoomLevel como dependência
	);

	const editarItem = (rowData) => {
		navigate(`/form-setor/${rowData.id}`);
	};

	// const excluirItem = (rowData) => {
	// 	alert(`Você clicou no botão para a linha com ID ${rowData.nome}`);
	// };

	const getItems = async () => {
		try {
			setIsLoading(true);
			const response = await setorService.get();
			setData(response);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.log(error);
		}
	};

	useEffect(() => {
		getItems();
	}, []);

	return (
		<Loading isLoading={isLoading}>
			<div className="page-content">
				<Breadcrumbs
					botaoLink={"/form-setor"}
					botao={"Adicionar Setor"}
					title="Setores"
				/>

				<div
					className="container-fluid"
					style={{
						backgroundColor: "white",
						padding: 20,
						borderRadius: 10,
						marginTop: 25,
					}}
				>
					<DynamicMaterialTable columns={columns} data={data} />
				</div>
			</div>
		</Loading>
	);
};
Setores.propTypes = {
	preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Setores);
